module.exports = __webpack_public_path__ + "static/sso-logo-f4a2d86977053c002633148e57c9481a.png";